import { render, staticRenderFns } from "./GoToResourceList.vue?vue&type=template&id=848d7d7e&scoped=true&"
import script from "./GoToResourceList.vue?vue&type=script&lang=js&"
export * from "./GoToResourceList.vue?vue&type=script&lang=js&"
import style0 from "./GoToResourceList.vue?vue&type=style&index=0&id=848d7d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d7d7e",
  null
  
)

export default component.exports